"use strict";
const _ = require('lodash');
module.exports = entity => {
    const { endCustomerOrganizationMemberships } = entity;
    if (!endCustomerOrganizationMemberships ||
        endCustomerOrganizationMemberships.length === 0) {
        return entity;
    }
    return {
        ...entity,
        endCustomerOrganizationMemberships: endCustomerOrganizationMemberships.map(x => {
            const limitedCustomerSubUnit = _.pick(x.customerSubUnit, [
                'id',
                'customerNumber',
                'chain',
                'customerType',
                'name',
            ]);
            return {
                ...x,
                customerSubUnit: limitedCustomerSubUnit,
            };
        }),
    };
};
